<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
        icon="mdi-earth"
        icon-action="mdi-pencil-outline"
        title="Site"
        :subtitle="location.data ? location.data.website_url : formData.website_url"
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Site
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="formValid" lazy-validation @submit="e => e.preventDefault()">
          <v-text-field
            v-model="formData.website_url"
            :rules="siteRules"
            required
            outlined
            v-on:keyup.enter="() => callAction()"
          ></v-text-field>

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" small v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn :loading="loading" color="primary" text @click="callAction">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem';
import { mapState } from 'vuex';
import { get } from 'lodash';
import {TYPE_UPDATE_LOCATION_URL} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm';

export default {
  name: 'LocationSiteModal',
  props: {
    action: Function,
    bulkUpdate: {
      type: Boolean
    },
    alertScheduleTask: Array,
  },
  components: {
    LocationInfoItem,
    ScheduleForm
  },
  methods: {
    cancel() {
      this.open = false
      this.resetData()
    },
    resetData() {
      const { website_url } = this.formDataOriginal
      this.formData.website_url = website_url
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'website_url')
      }
    },
    callAction: async function() {
      if (!this.$refs.form.validate()) {
        return false
      }

      if (this.bulkUpdate) {
        this.$emit('savePayload', 'website_url', this.formData.website_url)
      } else if (this.action) {
        this.loading = true
        await this.action(this.formData)
        this.loading = false
      }

      this.open = false
    },
    changeScheduleDate(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    }
  },
  computed: {
    ...mapState({
      location: (state) => state.locations.location
    })
  },
  beforeDestroy() {
    this.resetData()
  },
  mounted() {
    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_URL) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    formDataOriginal: {},
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_URL,
      website_url: '',
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: ''
    },
    siteRules: [(v) => !!v || 'O site é obrigatório'],
    alertScheduledTask: null,
  }),
  watch: {
    location(location) {
      if (!this.bulkUpdate) {
        this.formData.website_url = get(location, 'data.website_url')
        this.formDataOriginal.website_url = get(location, 'data.website_url')
      }
    },
    open(open) {
      if (open && !this.bulkUpdate) {
        this.formData.website_url = get(this.location, 'data.website_url')
        this.formDataOriginal.website_url = get(this.location,'data.website_url')
      }
    }
  }
};
</script>

<style scoped></style>
